import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_onsite">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_img_onsite">
              <StaticImage
                src="../../../images/case-studies/onsite/project-goals.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={638}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              Project <span>Goals</span>
            </h1>
            <p>
              The primary goal of TekRevol in creating OnSite Social was to
              ensure productive interactions among the users considering their
              vicinity with a powerful platform. The key objectives were based
              on fostering connections for users with potential friends,
              business contacts, or individuals of interest by leveraging
              location due to cutting-edge location-based technology.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
